import React from 'react'
import styled from 'styled-components'
import { css } from '@styled-system/css'
import { Button, Flex, Headline } from 'ui/acro'
import { P } from 'ui/bend'

const TrialCtaBoxContainer = styled(Flex)(() =>
  css({
    mt: ['0', '110px'],
    mb: ['0', '110px'],
    backgroundColor: 'rgba(255 , 255, 255, 0.9)',
    textAlign: 'center',
    padding: ['50px 50px 0', '60px', '70px 60px 70px 60px'],
    flexDirection: ['column'],
    maxWidth: ['auto', '45%', '61%']
  })
)

const TrialCtaBox = ({ cta, body, title, onClickBtn }) => {
  const button = {
    text: cta || 'Start my free trial',
    link: `/surveys/onboarding`,
    onClickBtn: onClickBtn
  }

  return (
    <TrialCtaBoxContainer>
      {title && (
        <Headline as='h2' fontSize={['37px']}>
          {title}
        </Headline>
      )}
      {body && (
        <P pt={['16px', '26px']} pb={['16px', '36px']}>
          {body}
        </P>
      )}
      {onClickBtn && (
        <Button
          as='a'
          className='unstyled'
          href={button.link}
          variant={'primary'}
          aria-label={button.text}
          onClick={() => {
            button.onClickBtn()
          }}
        >
          {button.text}
        </Button>
      )}
    </TrialCtaBoxContainer>
  )
}

export default TrialCtaBox
